import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Image, Link, Title } from '@landing/ui';

import * as styles from './Slide.module.scss';

export default function Slide({ cardId, img, title, description, link, setActive }) {
  const [inViewRef, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView && setActive) {
      setActive(cardId);
    }
  }, [inView, cardId, setActive]);

  return (
    <Link href={link} className={styles.slide} id={cardId} innerRef={inViewRef}>
      <Image className={styles.picture} classImage={styles.img} src={img} />
      <div className={styles.content}>
        <Title tag="h3" className={styles.title}>
          {title}
        </Title>
        <p className={styles.description}>{description}</p>
      </div>
    </Link>
  );
}
